
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"x":".5","y":".5","width":"28","height":"27","rx":"3.5","fill":"#fff","stroke":"#7B01B5"}}),_c('path',{attrs:{"d":"M16.985 10.85V9.275c0-.418-.167-.818-.465-1.114a1.595 1.595 0 00-1.123-.46H9.838c-.421 0-.825.165-1.123.46a1.568 1.568 0 00-.465 1.114v9.45c0 .418.167.819.465 1.114.298.295.702.461 1.123.461h5.56c.42 0 .824-.166 1.122-.461.298-.295.465-.696.465-1.114V17.15M12.221 14h9.529m0 0l-2.382-2.362M21.75 14l-2.382 2.363","stroke":"#7B01B5","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    